import { arrow } from "@/designSystemIcons";
import { cn } from "@/lib/utils";

type Props = {
  open: boolean;
  onToggleOpen: () => void;
  children: React.ReactNode;
  sectionName: string;
};

export const SbcSetsSection = ({
  children,
  onToggleOpen,
  open,
  sectionName,
}: Props) => {
  return (
    <div
      className={cn(
        "flex flex-col w-full gap-y-4 max-w-[1460px] mx-auto",
        open && "min-h-[328px]",
      )}
    >
      <div
        className="flex flex-row items-center cursor-pointer h-7 rounded-lg bg-new-gray-825 px-2 text-dark-tertiary justify-between w-full"
        onClick={() => onToggleOpen()}
      >
        <span>{sectionName}</span>
        <span className={cn("w-3", !open && "rotate-180")}>{arrow}</span>
      </div>
      <section className="relative gap-4 items-start justify-center flex flex-wrap">
        {open && children}
      </section>
    </div>
  );
};
